import { render, staticRenderFns } from "./CategoryHub.vue?vue&type=template&id=549b605c&scoped=true"
import script from "./CategoryHub.vue?vue&type=script&lang=js"
export * from "./CategoryHub.vue?vue&type=script&lang=js"
import style0 from "./CategoryHub.vue?vue&type=style&index=0&id=549b605c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b605c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TruncateText: require('/app/components/TruncateText.vue').default,CategoryHubFinder: require('/app/components/CategoryHubFinder.vue').default,Header: require('/app/components/Header.vue').default,CollectionPageStructuredData: require('/app/components/CollectionPageStructuredData.vue').default,CategoryHubTile: require('/app/components/CategoryHubTile.vue').default})
